import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '../assets/img/Rectangle.jpg'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "w-full relative flex my-[15px] justify-center items-start" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "relative h-full px-[10px] flex justify-center items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Avatar",
    class: "md:w-[50px] md:h-[50px] w-[30px] h-[30px] rounded-[50%]"
  })
], -1)
const _hoisted_4 = { class: "w-full text-left px-[10px]" }
const _hoisted_5 = { class: "text-blue-600 font-bold" }
const _hoisted_6 = { class: "py-[10px]" }
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "text-blue-500" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "relative h-full px-[10px] flex justify-center items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Avatar",
    class: "md:w-[50px] md:h-[50px] w-[30px] h-[30px] rounded-[50%]"
  })
], -1)
const _hoisted_12 = { class: "w-full text-left px-[10px]" }
const _hoisted_13 = { class: "text-blue-600 font-bold" }
const _hoisted_14 = { class: "py-[10px]" }
const _hoisted_15 = { class: "flex" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "text-blue-500" }
const _hoisted_19 = {
  key: 2,
  class: "w-full relative flex justify-center items-center flex-wrap text-center p-[20px] font-semibold text-sm text-blue-950"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", null, "Pas de commentaire disponible", -1)
const _hoisted_21 = [
  _hoisted_20
]

import ResponseComponent from '../components/Responses.vue';
import { ref } from 'vue';

interface Comment {
  id: number;
  username: string;
  content: string;
  responses: Response[];
  showResponseForm: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'One_comment',
  props: {
    latestComment: {},
    allComments: {},
    isSuperUser: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;
const showResponseForm = ref(false);

const toggleResponseForm = () => {
  showResponseForm.value = !showResponseForm.value;
};

const toggleResponseForm1 = (commentId: number) => {
  // Trouver le commentaire correspondant dans la liste et basculer son état showResponseForm
  const comment = props.allComments.find(c => c.id === commentId);
  if (comment) {
    comment.showResponseForm = !comment.showResponseForm;
  }
};


return (_ctx: any,_cache: any) => {
  return (_ctx.latestComment)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.latestComment.username), 1),
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.latestComment.content), 1),
            _createElementVNode("div", _hoisted_7, [
              (_ctx.isSuperUser)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: toggleResponseForm
                  }, "Répondre"))
                : _createCommentVNode("", true)
            ]),
            (showResponseForm.value)
              ? (_openBlock(), _createBlock(ResponseComponent, {
                  key: 0,
                  commentId: _ctx.latestComment.id,
                  username: _ctx.latestComment.username
                }, null, 8, ["commentId", "username"]))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.latestComment.responses.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.latestComment.responses, (response) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: response.id,
                  class: "w-full relative my-[5px] bg-gray-200 md:p-[20px] p-[10px]"
                }, [
                  _createElementVNode("p", null, [
                    _createElementVNode("strong", _hoisted_9, _toDisplayString(response.username) + " :", 1),
                    _createTextVNode(" " + _toDisplayString(response.content), 1)
                  ])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]))
    : (_ctx.allComments.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allComments, (comment) => {
            return (_openBlock(), _createElementBlock("div", {
              key: comment.id,
              class: "w-full relative my-[15px] flex justify-center items-start"
            }, [
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("h1", _hoisted_13, _toDisplayString(comment.username), 1),
                _createElementVNode("p", _hoisted_14, _toDisplayString(comment.content), 1),
                _createElementVNode("div", _hoisted_15, [
                  (_ctx.isSuperUser)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: ($event: any) => (toggleResponseForm1(comment.id))
                      }, "Répondre", 8, _hoisted_16))
                    : _createCommentVNode("", true)
                ]),
                (comment.showResponseForm)
                  ? (_openBlock(), _createBlock(ResponseComponent, {
                      key: 0,
                      commentId: comment.id,
                      username: comment.username
                    }, null, 8, ["commentId", "username"]))
                  : _createCommentVNode("", true),
                (comment.responses.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(comment.responses, (response) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: response.id,
                          class: "w-full relative my-[5px] bg-gray-200 md:p-[20px] p-[10px]"
                        }, [
                          _createElementVNode("p", null, [
                            _createElementVNode("strong", _hoisted_18, _toDisplayString(response.username) + " :", 1),
                            _createTextVNode(" " + _toDisplayString(response.content), 1)
                          ])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_21))
}
}

})